import { Box, Chip, Tabs, Tab, Skeleton, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { Link } from "react-router-dom";
import { rem, goLink } from "assets/js/common";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";
import { loadAlert, loadFavAlert } from "redux/reducers/top";

const cookies = new Cookies();
const useStyles = makeStyles((theme) => ({
  benefit: {
    "&.honeyBenefit": {
      paddingBottom: rem(60),
      "& .honey-tab": {
        background: theme.palette.primary.main,
        padding: `${rem(35)} 0 ${rem(45)}`,
        "& .honey-txt": {
          padding: `0 ${rem(30)} ${rem(5)} ${rem(30)}`,
          "& span": {
            display: "block",
            color: theme.palette.common.white,
            "&.txt-top": {
              fontSize: rem(14),
              lineHeight: rem(22),
            },
            "&.txt-btm": {
              fontSize: rem(20),
              lineHeight: rem(26),
              fontWeight: 800,
              marginTop: rem(2),
              "& img": {
                width: rem(20),
                height: rem(21),
                marginLeft: rem(10),
              },
            },
          },
          "& .skeleton-tab": {
            "& .MuiSkeleton-root + .MuiSkeleton-root": {
              marginLeft: rem(15),
            },
          },
        },
        "& .MuiTabs-root": {
          "& .MuiTabs-scroller": {
            background: theme.palette.primary.main,
            borderBottom: "none",
            "& .MuiButtonBase-root": {
              position: "relative",
              overflow: "visible",
              lineHeight: rem(15),
              color: "#f89385",
              "&.Mui-selected": {
                color: theme.palette.common.white,
              },
              "&:not(:first-of-type):before": {
                content: "''",
                width: "1px",
                height: "10px",
                background: theme.palette.common.white,
                opacity: "0.3",
                position: "absolute",
                left: rem(-15),
                top: "50%",
              },
            },
          },
        },
      },
      "& .list-items": {
        marginTop: rem(-38),
        padding: `0 ${rem(30)}`,
        "& .list-item": {
          marginTop: rem(30),
          "& .img-wrap": {
            position: "relative",
            paddingTop: "55.87%",
            background: "#fff",
            borderRadius: rem(10),
            overflow: "hidden",
            "& .img": {
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: "block",
              width: "100%",
              height: "100%",
              "& img": {
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover",
              },
            },
          },
          "& .tit": {
            fontWeight: 700,
            lineHeight: rem(20),
            marginTop: rem(20),
            paddingLeft: rem(10),
          },
          "& .date": {
            fontSize: rem(12),
            lineHeight: rem(16),
            color: "#999",
            marginTop: rem(8),
            paddingLeft: rem(10),
          },
          "&:first-child": {
            marginTop: 0,
          },
        },
        "& + .align-c": {
          marginTop: rem(30),
        },
      },
      "& .link-outlined": {
        padding: `0 ${rem(23)} 0 ${rem(30)}`,
        "& .ico-go": {
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/icon-next.svg)`,
          marginLeft: 0,
        },
      },
      "& button": {
        "& [class*='ico-']": {
          position: "relative",
          top: "-1px",
          width: rem(16),
          height: rem(16),
        },
        "&.link-outlined": {
          border: "1px solid #000",
          "&.link-primary": {
            borderColor: theme.palette.primary.main,
          },
        },
        "&.link-size-small": {
          height: rem(32),
          fontSize: rem(14),
          fontWeight: 400,
        },
        "&.link-primary": {
          color: theme.palette.primary.main,
        },
      },
      "& .nodata": {
        padding: `${rem(130)} 0 ${rem(118)}`,
        margin: `${rem(-38)} ${rem(30)} 0`,
        borderRadius: `${rem(10)} ${rem(10)} 0 0`,
        background: theme.palette.common.white,
      },
    },
  },
}));

export default function HoneyBenefit(props) {
  const classes = useStyles();

  const { data, loading } = useSelector((state) => state.home);
  const [val, setVal] = useState(0);
  const [items, setItems] = useState([]);
  const [link, setLink] = useState("");

  const history = useHistory();
  const dispatch = useDispatch();

  const { accessiblePages } = useSelector((state) => state.user);

  let favInfo = cookies.get("favInfo");

  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
  };

  const getItems = () => {
    if (data) {
      switch (val) {
        case 0:
          setItems(
            data.honeyBenefitEventList && data.honeyBenefitEventList.list,
          );
          setLink("/event");
          break;
        case 1:
          setItems(data.honeyBenefitClubList && data.honeyBenefitClubList.list);
          setLink("/membership");
          break;
        case 2:
          setItems(
            data.honeyBenefitClickList && data.honeyBenefitClickList.list,
          );
          setLink("");
          break;
        default:
          setItems(
            data.honeyBenefitEventList && data.honeyBenefitEventList.list,
          );
          setLink("/event");
          break;
      }
    }
  };

  const goClubList = () => {
    const token = cookies.get("X-AUTH-TOKEN");
    if (token) {
      history.push("/membership");
    } else {
      dispatch(loadAlert(true));
    }
  };

  const checkLink = (link) => {
    const token = cookies.get("X-AUTH-TOKEN");
    if (link.indexOf("/") == 0) {
      let find = accessiblePages.find((page) => link.indexOf(page) > -1);
      if (find) {
        history.push(link);
      } else {
        if (token) {
          history.push(link);
        } else {
          dispatch(loadAlert(true));
        }
      }
    } else {
      goLink(link);
    }
  };

  useEffect(() => {
    getItems();
  }, [val]);

  useEffect(() => {
    if (data) {
      getItems();
    }
  }, [data]);

  if (loading)
    return (
      <div className={"honeyBenefit " + classes.benefit}>
        <div className="honey-tab">
          <div className="honey-txt">
            <span className="txt-top">
              <Skeleton variant="rectangular" width={100} height={16} />
            </span>
            <span className="txt-btm">
              <Skeleton variant="rectangular" width={161} height={24} />
            </span>
            <Box
              className="skeleton-tab"
              display="flex"
              spacing={1}
              mt={6}
              mb={4}
            >
              <Skeleton variant="rectangular" width={40} height={15} />
              <Skeleton variant="rectangular" width={27} height={15} />
              <Skeleton variant="rectangular" width={72} height={15} />
            </Box>
          </div>
        </div>
        <ul className="list-items">
          {[...Array(2)].map((item, i) => (
            <li className="list-item" key={`skel-${i}`}>
              <div className="img-wrap">
                <div className="img">
                  <Skeleton variant="rectangular" width={"100%"} height={176} />
                </div>
              </div>
              <div className="tit">
                <Skeleton variant="rectangular" width={180} height={16} />
              </div>
              <div className="date">
                <Skeleton variant="rectangular" width={100} height={12} />
              </div>
            </li>
          ))}
        </ul>
      </div>
    );

  return (
    // <div className={"honeyBenefit " + classes.benefit}>
    //   <div className="honey-tab">
    //     <div className="honey-txt">
    //       <span className="txt-top">놓친 혜택 없나요?</span>
    //       <span className="txt-btm">
    //         꿀혜택 다 모으기!
    //         <img
    //           src={`${process.env.PUBLIC_URL}/images/icon/icon-benefit.svg`}
    //         />
    //       </span>
    //     </div>
    //     <Tabs value={val} onChange={handleChangeTab}>
    //       <Tab label="이벤트" />
    //       <Tab label="클럽" />
    //       <Tab label="쇼핑 후 클릭" />
    //     </Tabs>
    //   </div>

    //   {items && items.length > 0 ? (
    //     <>
    //       <ul className="list-items">
    //         {items.map((item, i) => (
    //           <li
    //             key={`list-${i}`}
    //             className="list-item"
    //             onClick={() => {
    //               checkLink(item.link);
    //             }}
    //           >
    //             <div className="img-wrap">
    //               <div className="img">
    //                 <LazyCDNImage key={item.imgUrl} cdnUrl={item.imgUrl} />
    //               </div>
    //             </div>
    //             <div className="tit">{item.ttl}</div>
    //             <div className="date">{item.periodInfo}</div>
    //           </li>
    //         ))}
    //       </ul>
    //       {val == 0 ? (
    //         <div className="align-c">
    //           <Link
    //             to={link}
    //             className="link-outlined link-size-small btn-rounded end-icon"
    //           >
    //             전체보기
    //             <i className="ico-go" />
    //           </Link>
    //         </div>
    //       ) : val == 1 ? (
    //         <div className="align-c">
    //           <Button
    //             className="link-outlined link-size-small btn-rounded end-icon"
    //             onClick={goClubList}
    //           >
    //             전체보기
    //             <i className="ico-go" />
    //           </Button>
    //         </div>
    //       ) : (
    //         <></>
    //       )}
    //     </>
    //   ) : (
    //     <div className="nodata">
    //       <Box className="illust">
    //         <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
    //       </Box>
    //       <p className="color-info">등록된 컨텐츠가 없습니다</p>
    //     </div>
    //   )}
    // </div>
    <div></div>
  );
}
